//import { MarketGlobalInfo } from 'api/ordersAPICall';
import { GamesList } from 'api/gamesCallDev';
import { LogStream } from 'generics/common';
import { SettingsInjections } from 'generics/settingsInjections';
import { objectMap } from 'generics/utils';

LogStream.enable( "GLOBALMARKETCONFIGSTORAGE" );

class GlobalMarketConfigStorage  {
  constructor()  {
    this.games = {};
    this.ready = false;
  }


  load()  {
    return GamesList().then( ( resp ) =>  {
      this.games = {};

      const appMode = SettingsInjections.getMode();
      const allowedGames = (appMode == 'pixstorm') ? [ '1067', '1131' ] : null;

      objectMap( resp.games, ( game ) =>  {
          if (game.appid < 1)
            return;

          if (!game.briefName || !game.name || !game.icon || !game.desc)
            return;

          if (allowedGames && !allowedGames.includes(game.appid.toString()))
            return;

          this.games[ game.appid ] = game;
        });

      this.ready = true;
      LogStream("GLOBALMARKETCONFIGSTORAGE").info( "load (", this, ")" );
      return resp;
    });
  }

  check()  {
    if ( !this.ready )
      throw new Error( "GlobalMarketConfigStorage was not loaded properly ");
  }


  unresolvedApp( appid )  {
    return {
        "appid"         : appid,
        "briefName"     : "N/A",
        "name"          : "N/A",
        "desc"          : [ "N/A" ],
        "icon"          : "images/loader.gif",
        "banner"        : "images/loader.gif",
        "unresolved"    : true
      };
  }

  resolveAppId( appid )  {
    this.check();
    return this.games[appid] || this.unresolvedApp( appid );
  }


  getAppIdList()  {
    this.check();
    return Object.keys(this.games);
  }

};


let G_marketConfigStorage = new GlobalMarketConfigStorage(); // FIXME, should be separate component
export default G_marketConfigStorage;
